export default __webpack_public_path__ + "static/media/trial-logs.5417e5b2.png";